// gatsby-browser.js
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/700.css';

import { initGTM, trackPageView } from './src/utils/gtm';

// Initialize on client entry - but with a delay to prevent blocking
export const onClientEntry = () => {
  if (typeof window !== 'undefined') {
    // Delay GTM initialization slightly to not block initial render
    setTimeout(() => {
      initGTM();
    }, 100);
  }
};

// Track page views on route changes
export const onRouteUpdate = ({ location }) => {

  if (typeof window !== 'undefined' && window.initialPageviewSent) {
    // Only track subsequent page views (initial one is handled in initGTM)
    trackPageView(location.pathname, document.title);
  }
};
